export var MessageQueue;
(function (MessageQueue) {
    MessageQueue["HEALTH_CHECK"] = "health-check";
    MessageQueue["NOTIFICATION"] = "notification";
    MessageQueue["TRANSACTION"] = "transaction";
    MessageQueue["AUDIT"] = "audit";
    MessageQueue["USER_ACTIVITY"] = "user-activity";
    MessageQueue["KYC_PROCESSING"] = "kyc-processing";
})(MessageQueue || (MessageQueue = {}));
export var MessageEvent;
(function (MessageEvent) {
    MessageEvent["HEALTH_CHECK"] = "health_check";
    MessageEvent["TRANSACTION_CREATED"] = "transaction_created";
    MessageEvent["TRANSACTION_UPDATED"] = "transaction_updated";
    MessageEvent["USER_LOGGED_IN"] = "user_logged_in";
    MessageEvent["USER_LOGGED_OUT"] = "user_logged_out";
    MessageEvent["KYC_UPDATED"] = "kyc_updated";
    MessageEvent["KYC_PROCESS_REQUIRED"] = "kyc_process_required";
})(MessageEvent || (MessageEvent = {}));
//# sourceMappingURL=messaging.types.js.map